import { Box, Container, SxProps } from '@mui/material';
import { ReactNode } from 'react';

import { SizingMultiplier } from '../../sizing-multiplier.constant';

type SmConstrainedPageBodyProps = {
  children: ReactNode;
  /**
   * `fill` — outer box grows in a flex column (e.g. under PageContent) so children + footer can use flex layout.
   * `block` — shrink-to-content width constraint only.
   */
  variant?: 'block' | 'fill';
};
const defaultStyles: SxProps = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const SmConstrainedPageBody = ({ children, variant = 'block' }: SmConstrainedPageBodyProps) => {
  const flexFill = variant === 'fill' ? defaultStyles : {};

  return (
    <Box
      sx={{
        width: '100%',
        ...flexFill,
      }}>
      <Container
        maxWidth="sm"
        disableGutters
        sx={{
          px: SizingMultiplier.sm,
          ...flexFill,
        }}>
        {children}
      </Container>
    </Box>
  );
};
